import React from 'react';
import { Field, useField, useFormikContext } from 'formik';
import styles from './filter.module.sass';

type Props = {
  name: string;
  label: string;
  selected?: boolean;
};

const FilterCheckBox = ({ name, label, selected }: Props) => {
  const [field] = useField(name);
  const { submitForm } = useFormikContext();
  return (
    <>
      <label
        className={`${styles.button} ${styles.single} ${
          selected ? styles.selected : ''
        }`}
        htmlFor={name}
      >
        {label}
      </label>
      <Field
        className="sr"
        type="checkbox"
        id={name}
        name={name}
        onChange={(e) => {
          field.onChange(e);
          submitForm();
        }}
      />
    </>
  );
};

export default FilterCheckBox;
